import React from 'react';

const Upperfooter = () => {
  return (
   <>
   <div className="container-fluid py-5" style={{backgroundColor:'#c93c09'}}>
   <div className="row">
     <h5 className='text-light text-center pb-3'>YOU DREAM IT, WE DESIGN IT</h5>
   </div>
   <div className="row">
     <div className="col-md-2"></div>
     <div className="col-md-8">
     <h1  className='text-light text-center'  style={{fontWeight:'800'}}>WE CAN BUILD YOUR RESIDENTIAL OF
     YOUR DREAMS</h1>
     </div>
     <div className="col-md-2"></div>
   </div>

   </div>
   </>
  )
}

export default Upperfooter